import { useAuth } from '@modules/auth/hooks';
import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { fetchCampaignTrackingOverviewData } from '../services/campaign/tracking/campaign-tracking-overview.service';
import { STUDY_INSIGHTS_CAMPAIGN_TRACKING_OVERVIEW } from '../constants';
import {
  CampaignTrackingOverviewData,
  FetchCampaignTrackingOverviewParams,
} from '../services/campaign/tracking/campaign-tracking.types';

const useQueryCampaignTrackingOverviewData = <TError = unknown>(
  params: FetchCampaignTrackingOverviewParams,
  options?: Omit<
    UseQueryOptions<CampaignTrackingOverviewData, TError, CampaignTrackingOverviewData, Array<string | undefined>>,
    'initialData' | 'queryFn' | 'queryKey'
  >,
): UseQueryResult<CampaignTrackingOverviewData> => {
  const { isAuthenticated } = useAuth();

  const enabledOption = options?.enabled !== undefined ? !!options?.enabled : true;

  return useQuery(
    [STUDY_INSIGHTS_CAMPAIGN_TRACKING_OVERVIEW, params.groupKey],
    async () => await fetchCampaignTrackingOverviewData(params),
    {
      ...options,
      enabled: isAuthenticated === true && enabledOption,
    },
  );
};
export default useQueryCampaignTrackingOverviewData;
